<div
  [ngClass]="classNames()"
  class="base-button-group mobile-is-space-between"
  [ngStyle]="styles()"
>
  <ng-content></ng-content>
</div>
